/**
 * `/admin_inbox` is restricted to a single operator account (half-claw in flux).
 * Compare case-insensitively to Supabase Auth `user.email`.
 */
export const INBOX_ADMIN_EMAIL = 'tansaku@gmail.com';

export function emailIsInboxAdmin(email) {
  if (!email || typeof email !== 'string') return false;
  return email.trim().toLowerCase() === INBOX_ADMIN_EMAIL;
}
